<template lang="pug">
  v-container
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    AddOrEditBusinessDialog( v-if="openBusinessDialog" :openBusinessDialog="openBusinessDialog"
      :businessToEdit="businessToEdit" @closeBusinessDialog="closeBusinessDialog($event)")

    v-card-title(ref="title") {{ $t('businessPage.pageTitle') }}

    v-card.align-self-start(v-if="business !== null" flat)
      v-toolbar(dense flat v-if="$vuetify.breakpoint.mdAndUp")
        v-btn( @click="onDialogClick" color="primary" ) {{ $t('businessPage.addNewBusinessButtonLabel') }}
      v-card-text.overflow-auto.pt-0
        v-list
          v-list-item.listItem.pl-0(v-for="(item, idx) in business" :key="idx" @click="onDialogClick(item)" )
            v-list-item-content.subtitle-1 {{idx + 1}}. {{ item.name }}
      v-fab-transition
        v-btn.mb-9( v-if="$vuetify.breakpoint.smAndDown" @click="onDialogClick" color="pink"
          right bottom fixed fab dark)
          v-icon fas fa-plus
    v-skeleton-loader(v-else type="list-item@10" )

</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import {Action} from "vuex-class";
import {FETCH_BUSINESS_DATA} from "@/store/action-types";
import BusinessModel from "@/model/menu/BusinessModel";
import AddOrEditBusinessDialog from "@/components/business/AddOrEditBusinessDialog.vue";

@Component({
  components: {
    AddOrEditBusinessDialog
  }
})

export default class BusinessPage extends Vue {
  $refs!: {
    title: HTMLElement
  }

  @Action(FETCH_BUSINESS_DATA) fetchBusinessData!: { (): Promise<BusinessModel[]> }

  private business: BusinessModel[] | null = null
  private fetchInProgress: boolean = false
  private openBusinessDialog: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private businessToEdit: BusinessModel | null = null
  private cardHeight: string = ''

  async fetchBusiness(): Promise<void> {
    this.fetchInProgress = true
    try {
      this.business = await this.fetchBusinessData()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  onDialogClick(item?: BusinessModel): void {
    if (item && item.name) {
      this.businessToEdit = item
      this.openBusinessDialog = true
    } else {
      this.businessToEdit = null
      this.openBusinessDialog = true
    }
  }

  closeBusinessDialog(businessAction: string): void {
    if (businessAction === "added") {
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.$t('businessPage.businessSuccessfullyAddedMessage').toString()
      this.fetchBusiness()
    } else if (businessAction === "edited") {
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.$t('businessPage.businessSuccessfullyEditedMessage').toString()
      this.fetchBusiness()
    }
    this.openBusinessDialog = false
  }

  onResize () {
    if(this.$vuetify.breakpoint.mdAndUp && this.$refs.title) {
      const vh = window.innerHeight
      const titleHeight = this.$refs.title.scrollHeight
      this.cardHeight = `height: calc(${vh}px - 188px - ${titleHeight}px)`
    } else if(this.$vuetify.breakpoint.smAndDown && this.$refs.title) {
      const vh = window.innerHeight
      if(vh < 500) {
        this.cardHeight = `height:200px`
      }else {
        const titleHeight = this.$refs.title.scrollHeight
        this.cardHeight = `height: calc(${vh}px - 140px - ${titleHeight}px )`
      }
    }
  }

  mounted(): void {
    this.fetchBusiness()
  }
}
</script>

<style lang="stylus" scoped>

.listItem
  cursor pointer

</style>